import React from 'react'
import ReactDOM from 'react-dom/client'
import 'material-symbols'
import {AuthProvider} from "react-oidc-context"
import {oidc, page} from "./config"
import {app} from "./components"
import './index.scss'
import {keyboardEventStore, tenantStore} from "./store"
import {observer} from "mobx-react"

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

document.addEventListener('keydown', (event) => {
    keyboardEventStore.onKeyDown(event)
})

let pathname = window.location.pathname.replaceAll('/login_redirect', '')
const path = `/${pathname}`.replaceAll(/\/+/g, '/')

const AuthProviderObserverWrapper = observer(function AuthProviderObserverWrapper() {
    if (!tenantStore.tenant) {
        return <app.TenantSelectApp />
    }

    const authority = tenantStore.config?.authority

    return <AuthProvider {...oidc.config} authority={authority} redirect_uri={redirect_uri}>
        <app.AuthenticatedApp />
    </AuthProvider>
})

const redirect_uri = (page.baseUrl + path)
root.render(
    <React.StrictMode>
        <AuthProviderObserverWrapper />
    </React.StrictMode>
)
